export function formatGreeting(name: string): string {
  const hour = new Date().getHours();
  const firstName = name.split(' ')[0];
  if (hour < 12) return `Buenos días, ${firstName} 👋`;
  if (hour < 19) return `Buenas tardes, ${firstName} 👋`;
  return `Buenas noches, ${firstName} 👋`;
}
